export default __webpack_public_path__ + "static/media/poppins-devanagari-400-normal.64d5f06e.woff2";